import { useState } from 'react'
import ReactPlayer from 'react-player/lazy'
import Image from 'next/image'

const Thumbnail = () => (
  <Image
    src='/blog/launch/hero.png'
    layout='fill'
    className='absolute top-0 left-0 w-full bg-white'
  />
)

export function BlogDemoVideo() {
  const [playing, setPlaying] = useState(false)

  return (
    <div className='relative py-40 mx-auto sm:py-60'>
      <div className='relative'>
        <div
          className='absolute left-0 right-0 z-10 w-full overflow-hidden transform -translate-y-1/2 rounded-lg shadow-lg'
          style={{ paddingTop: `56.25%` }}
        >
          {playing ? (
            <ReactPlayer
              url='https://vimeo.com/545863087'
              className='absolute top-0 left-0 rounded-lg'
              playing={playing}
              width='100%'
              height='100%'
              controls
              fallback={<Thumbnail />}
            />
          ) : (
            <>
              <div>
                <Thumbnail />
                <div className='absolute top-0 bottom-0 left-0 right-0 bg-gray opacity-40'></div>
              </div>
              <button
                className='absolute z-20 flex items-center justify-center w-16 h-16 -mt-8 transform -translate-x-1/2 -translate-y-1/2 rounded-full shadow-small border-bright-blue border-3 sm:h-20 sm:w-20 top-1/2 left-1/2 play-btn focus:outline-none'
                onClick={() => setPlaying(true)}
                aria-label='Play video'
              >
                <p className='absolute z-0 hidden px-8 py-5 text-lg font-medium tracking-wide shadow-small text-gray rounded-xl bg-gray-50 gotham top-full w-80 sm:block'>
                  Watch Max demo caching
                  <span className='block mt-1 text-sm opacity-70'>
                    Including smart purging in 4 min
                  </span>
                </p>
                <div className='absolute top-0 bottom-0 left-0 right-0 z-0 border rounded-full play-btn-bg bg-blue' />
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='relative w-8 h-8 sm:w-10 sm:h-10 play-btn-icon'
                  fill='none'
                  viewBox='0 0 24 24'
                >
                  <path
                    fill='#fff'
                    stroke='#fff'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M7 4v16l13-8L7 4z'
                  ></path>
                </svg>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
